/**
 * Rappel des horaires de montage/démontage, en haut du formulaire.
 *
 * Le bandeau ne saisit rien : il reflète `#rentStartTime` / `#rentEndTime`, les deux
 * champs cachés qui font foi au submit. Les champs visibles restent en tête de
 * l'étape « Matériel ».
 *
 * Deux précautions valent d'être expliquées :
 *
 * 1. flatpickr écrit les champs CACHÉS sans émettre d'événement — écouter `change`
 *    sur eux ne donnerait jamais rien. On écoute donc les champs VISIBLES, dont les
 *    événements bouillonnent, puis on relit les champs cachés.
 * 2. On relit au tour de boucle suivant : au moment où le `change` du champ visible
 *    nous parvient, flatpickr n'a pas forcément encore recopié la valeur dans le
 *    champ caché, et on afficherait l'heure précédente.
 */

const BANNER = '[data-setup-hours]';
const FORMAT_HEURE = /^\d{1,2}:\d{2}$/;

function lireHeure(id) {
    const el = document.getElementById(id);
    const valeur = el && el.value ? el.value.trim() : '';
    // "Invalid time" est une valeur que le picker pose réellement dans les champs
    // cachés lorsqu'une date est effacée ; l'afficher serait pire que se taire.
    return FORMAT_HEURE.test(valeur) ? valeur : '';
}

function rendre(banner) {
    const debut = lireHeure('rentStartTime');
    const fin = lireHeure('rentEndTime');

    if (!debut || !fin) {
        banner.hidden = true;
        return;
    }

    banner.hidden = false;
    banner.querySelector('[data-setup-hours-start]').textContent = debut;
    banner.querySelector('[data-setup-hours-end]').textContent = fin;
}

export function initSetupHoursBanner() {
    const banner = document.querySelector(BANNER);
    if (!banner) return;

    rendre(banner);

    const portee = banner.closest('.form-bookingapp') || document;
    const relire = () => window.setTimeout(() => rendre(banner), 0);

    // En capture : certains handlers du formulaire arrêtent la propagation.
    ['change', 'input'].forEach((evenement) => {
        portee.addEventListener(evenement, relire, true);
    });
}
